import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import StoreProvider from './providers/StoreProvider'
import RootProvider from './providers/RootProvider'

// Layouts
import DashboardLayout from './layouts/DashboardLayout'

// Pages
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import NotFoundPage from './pages/NotFoundPage'

// Products
import ProductsPage from './pages/dashboard/products/ProductsPage'
import ProductDetailPage from './pages/dashboard/products/ProductDetailPage'
import AddProductPage from './pages/dashboard/products/AddProductPage'
import EditProductPage from './pages/dashboard/products/EditProductPage'

// Customers
import CustomersPage from './pages/dashboard/customers/CustomersPage'

// Inventory
import InventoryPage from './pages/dashboard/inventory/InventoryPage'

// Purchases
import PurchasesPage from './pages/dashboard/purchases/PurchasesPage'
import PurchaseDetailPage from './pages/dashboard/purchases/PurchaseDetailPage'
import AddPurchasePage from './pages/dashboard/purchases/AddPurchasePage'
import EditPurchasePage from './pages/dashboard/purchases/EditPurchasePage'
import ReturnsPage from './pages/dashboard/purchases/ReturnsPage'
import ReturnDetailPage from './pages/dashboard/purchases/ReturnDetailPage'
import ReturnEditPage from './pages/dashboard/purchases/ReturnEditPage'
import AddReturnPage from './pages/dashboard/purchases/ReturnEditPage'

// Reports
import ReportsPage from './pages/dashboard/reports/ReportsPage'
import ActivitiesPage from './pages/dashboard/reports/ActivitiesPage'
import ExpensesPage from './pages/dashboard/reports/ExpensesPage'
import SalesReportPage from './pages/dashboard/reports/SalesReportPage'

// Sales
import SalesPage from './pages/dashboard/sales/SalesPage'
import CreateSalePage from './pages/dashboard/sales/CreateSalePage'
import DraftsPage from './pages/dashboard/sales/DraftsPage'
import SurplusSalesPage from './pages/dashboard/sales/SurplusSalesPage'

// Suppliers
import SuppliersPage from './pages/dashboard/suppliers/SuppliersPage'

// Settings
import BrandsPage from './pages/dashboard/settings/BrandsPage'
import BusinessPage from './pages/dashboard/settings/BusinessPage'
import CategoriesPage from './pages/dashboard/settings/CategoriesPage'
import ProfilePage from './pages/dashboard/settings/ProfilePage'
import RolesPage from './pages/dashboard/settings/RolesPage'
import ShopsPage from './pages/dashboard/settings/ShopsPage'
import ShopDetailPage from './pages/dashboard/settings/ShopDetailPage'
import AddShopPage from './pages/dashboard/settings/AddShopPage'
import EditShopPage from './pages/dashboard/settings/EditShopPage'
import UnitsPage from './pages/dashboard/settings/UnitsPage'
import UsersPage from './pages/dashboard/settings/UsersPage'
import WarrantiesPage from './pages/dashboard/settings/WarrantiesPage'

function App() {
  return (
    <StoreProvider>
      <RootProvider>
        <Routes>
          {/* Login */}
          <Route path="/" element={<LoginPage />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />

            {/* Products */}
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/:id" element={<ProductDetailPage />} />
            <Route path="products/add-product" element={<AddProductPage />} />
            <Route path="products/edit/:id" element={<EditProductPage />} />

            {/* Customers */}
            <Route path="customers" element={<CustomersPage />} />

            {/* Inventory */}
            <Route path="inventory" element={<InventoryPage />} />

            {/* Purchases */}
            <Route path="purchases" element={<PurchasesPage />} />
            <Route path="purchases/:id" element={<PurchaseDetailPage />} />
            <Route path="purchases/add" element={<AddPurchasePage />} />
            <Route path="purchases/edit/:id" element={<EditPurchasePage />} />
            <Route path="purchases/returns-all/returns" element={<ReturnsPage />} />
            <Route path="purchases/returns-all/returns/:id" element={<ReturnDetailPage />} />
            <Route path="purchases/returns-all/returns/edit/:id" element={<ReturnEditPage />} />
            <Route path="purchases/returns-all/returns/add" element={<AddReturnPage />} />

            {/* Reports */}
            <Route path="reports" element={<ReportsPage />} />
            <Route path="reports/activities" element={<ActivitiesPage />} />
            <Route path="reports/expenses" element={<ExpensesPage />} />
            <Route path="reports/sales" element={<SalesReportPage />} />

            {/* Sales */}
            <Route path="sales" element={<SalesPage />} />
            <Route path="sales/create" element={<CreateSalePage />} />
            <Route path="sales/drafts" element={<DraftsPage />} />
            <Route path="sales/surplus" element={<SurplusSalesPage />} />

            {/* Suppliers */}
            <Route path="suppliers" element={<SuppliersPage />} />

            {/* Settings */}
            <Route path="settings/brands" element={<BrandsPage />} />
            <Route path="settings/business" element={<BusinessPage />} />
            <Route path="settings/categories" element={<CategoriesPage />} />
            <Route path="settings/profile" element={<ProfilePage />} />
            <Route path="settings/roles" element={<RolesPage />} />
            <Route path="settings/shops" element={<ShopsPage />} />
            <Route path="settings/shops/:id" element={<ShopDetailPage />} />
            <Route path="settings/shops/add" element={<AddShopPage />} />
            <Route path="settings/shops/edit/:id" element={<EditShopPage />} />
            <Route path="settings/units" element={<UnitsPage />} />
            <Route path="settings/users" element={<UsersPage />} />
            <Route path="settings/warranties" element={<WarrantiesPage />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </RootProvider>
    </StoreProvider>
  )
}

export default App
